import { useMemo } from "react"
import { useOpco } from "."
import { Opco } from "../models"

export function useCompanyName(): string {
  const opco: Opco = useOpco()

  const companyName: string = useMemo<string>(() => {
    switch (opco) {
      case Opco.Noordhoff:
        return "Noordhoff"
      case Opco.Plantyn:
        return "Plantyn"
      case Opco.Liber:
        return "Liber"
    }
  }, [opco])

  return companyName
}
